import { FetchPointsResponseDTO } from "@repo/core/services/entities/Proposals";

export const getProposalServicePointsQueryKey = (
  productCode: string,
  brandCode: string
) => ["servicePoints", productCode, brandCode] as const;

export const getProposalServicePointsParams = (
  productCode: string,
  brandCode: string
) => ({
  strProduto: productCode,
  strBandeira: brandCode
});

export const findServicePointByCode = (
  servicePoints: FetchPointsResponseDTO | undefined,
  servicePointCode: string | undefined
) => {
  const normalizedCode = servicePointCode?.trim();

  if (!normalizedCode) {
    return null;
  }

  return (
    servicePoints?.find((point) => point.ponto.trim() === normalizedCode) ??
    null
  );
};
